<template>
  <div class="table-responsive table-responsive-md table-responsive-lg ">
    <table class="table table-hover table-striped">
      <thead>
        <slot name="columns">
          <tr>
            <th v-for="column in columns" :key="column" v-bind:class="{'w-5' : arrayColumns.includes(column), 'text-right' : actionColumns.includes(column), 'text-center' : column === 'active', 'col-id' : column === 'Id' || column === 'id' }">
              <div v-if="column == 'check_all'">
                  <input type="checkbox" :checked="isAllChecked" @change="checkAllItems($event)">
              </div>

              <span v-else>
                <slot name="thead" :column="column">
                  {{$t(column)}} <!-- fallback -->
                </slot>
              </span>

            </th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <td v-for="column in columns" :key="column" :class="{'col-id' : column === 'Id' || column === 'id'}"
                :data-order="sortKey (item, column)">
              <div v-if="column == 'show'">              
                  <router-link v-tooltip="$t('Visualizar')" class="btn btn-light border-0 btn-primary py-1" :to="section + '/' + item.id" >
                    <i class="nc-icon nc-zoom-split font-weight-bold"></i>
                  </router-link>
              </div>
              <!--<div v-else-if="column=='show_file'" class="text-center">
                <router-link class="btn btn-light border-0 btn-primary py-1" :to="section + '/' + item.parent_id" >
                  <i class="fas fa-eye"></i>
                </router-link>
              </div>-->
              <div v-else-if="column=='show_file'" class="d-flex justify-content-end">
                  <button class="btn btn-view-outline" v-tooltip="$t('Visualizar')" @click="onShowFile (item.id)">
                      <i class="icon-svg icon-eye-check"></i>
                  </button>
              </div>
              <!-- Columna única "Visualizar/Descargar": mismo patrón que
                   "Acciones" (editar+eliminar), siempre la última columna. -->
              <div v-else-if="column == 'view_download'" class="d-flex justify-content-end actions-cell">
                  <button class="btn btn-view-outline" v-tooltip="$t('Visualizar')" @click="onShowFile (item.id)">
                      <i class="icon-svg icon-eye-check"></i>
                  </button>
                  <button v-if="item.download_file" class="btn btn-download-outline" v-tooltip="$t('Descargar')" @click="onDonwloadFile (item.id)">
                      <i class="icon-svg icon-cloud-download"></i>
                  </button>
              </div>
              <div v-else-if="column == 'edit'" class="d-flex justify-content-end">
                  <router-link v-tooltip="$t('edit')" class="btn btn-edit-outline" :to="section + '/' + item.id">
                      <i class="icon-svg icon-edit"></i>
                  </router-link>
              </div>
              <div v-else-if="column == 'html_column'">
                <div class="font12" v-html="item.html_column"> </div>
              </div>
              <div v-else-if="column == 'edit_event'" class="d-flex justify-content-end">
                  <button v-tooltip="$t('edit')" class="btn btn-edit-outline" @click="onPressEdit (item)">
                      <i class="icon-svg icon-edit"></i>
                  </button>
              </div>
               <div v-else-if="column == 'delete_event'" class="d-flex justify-content-end">
                  <button v-if="isDeletable (item)" v-tooltip="$t('Eliminar')" class="btn btn-delete-outline" @click="onPressDelete (item, index)">
                      <i class="icon-svg icon-trash"></i>
                  </button>
              </div>
              <!-- Columna única "Acciones": editar + eliminar juntos, siempre
                   la última columna (a la derecha del todo). -->
              <div v-else-if="column == 'actions'" class="d-flex justify-content-end actions-cell">
                  <router-link v-tooltip="$t('edit')" class="btn btn-edit-outline" :to="section + '/' + item.id">
                      <i class="icon-svg icon-edit"></i>
                  </router-link>
                  <button v-if="isDeletable (item)" v-tooltip="$t('Eliminar')" class="btn btn-delete-outline" @click="onPressDelete (item, index)">
                      <i class="icon-svg icon-trash"></i>
                  </button>
              </div>
              <!-- Igual que "Acciones" pero para tablas embebidas (p.ej. usuarios
                   dentro del formulario de Compañías) donde editar debe abrir un
                   modal (@editEvent) en vez de navegar a otra ruta. -->
              <div v-else-if="column == 'actions_event'" class="d-flex justify-content-end actions-cell">
                  <button v-tooltip="$t('edit')" class="btn btn-edit-outline" @click="onPressEdit (item)">
                      <i class="icon-svg icon-edit"></i>
                  </button>
                  <button v-if="isDeletable (item)" v-tooltip="$t('Eliminar')" class="btn btn-delete-outline" @click="onPressDelete (item, index)">
                      <i class="icon-svg icon-trash"></i>
                  </button>
              </div>
              <div v-else-if="column == 'check_all'">
                  <!-- Bare <div>, same as the "check all" cell of the header:
                       the Bootstrap wrapper this used to carry
                       ("custom-control custom-checkbox") adds a 1.5rem
                       padding-left meant for the .custom-control-input /
                       .custom-control-label pair, which this markup no longer
                       uses (the checkbox is styled directly, see section 6 of
                       variations.scss). That padding was the only thing it
                       still contributed, and it pushed every row checkbox
                       24px to the right of the header one. -->
                  <input v-on:click="toggleChecklist(item.id,$event, index)"
                      type="checkbox" :id="'checkbox_'+item.id" :value="item.id" v-model="check_value" @change="onCheckItem">
              </div> 
              <div v-else-if="column == 'options'">
                  <router-link v-if="item.status_id == 1" v-tooltip="$t('edit')" class="btn btn-edit-outline" :to="section+'/' + item.id">
                      <i class="icon-svg icon-edit"></i>
                  </router-link>
                   <button  v-if="item.status_id == 2" v-tooltip="'Enviar Contrato'" class="btn border-0 text-primary py-1" @click="onSendContract (item.id)">
                      <i class="fas fa-envelope"></i>
                  </button>
                  <button  v-if="item.status_id == 3" v-tooltip="$t('AdjuntarContrato')" class="btn border-0 text-danger py-1" @click="onUploadContract (item)">
                      <i class="fas fa-upload"></i>
                  </button>
              </div> 
              <div v-else-if="column == 'download'">
                <button v-if="item.download" class="btn  border-0 text-dark py-1" v-tooltip="'Descargar Contrato'" @click="onDonwloadContract (item.id)">
                    <i class="fas fa-download"></i>
                </button>
              </div>
              <div v-else-if="column == 'path'">
                <!-- The parent builds "path" by walking the folder tree. folder_code is
                     only the fallback: it is written once when the document is
                     uploaded and does not follow moves or folder renames. -->
                {{ item.path != null ? item.path : item.folder_code }}
                <!--{{(item.url).replace ('CleverDocs/DOCUMENTOS', '').replace (item.file_name, '')}}-->
                <!--{{console.log (process.env.VUE_APP_NAME)}}-->
              </div>
              <div v-else-if="column == 'url'">
                {{(item.url).replace (item.file_name, '')}}
                <!--{{(item.url).replace ('CleverDocs/DOCUMENTOS', '').replace (item.file_name, '')}}-->
                <!--{{console.log (process.env.VUE_APP_NAME)}}-->
              </div> 
              <div v-else-if="column == 'company_name'">
                 <router-link tag="a" class="text-blue text-uppercase" :to="'/admin/admin_concursal/'+item.id">
                   {{item.company_name}}
                 </router-link>
              </div> 
              <div v-else-if="column == 'download_file'" class="d-flex justify-content-end">
                <button v-if="item.download_file" class="btn btn-download-outline" v-tooltip="'Descargar Archivo'" @click="onDonwloadFile (item.id)">
                    <i class="icon-svg icon-cloud-download"></i>
                </button>
              </div>
              <div v-else-if="column == 'show_image'" class="text-center">
                <button v-if="item.show_image" class="btn  border-0 text-dark py-1" v-tooltip="'Visualizar Archivo'" @click="onDonwloadEvent (item)">                            
                    <i class="fas fa-eye"></i>
                </button>
              </div>
              <div v-else-if="column == 'file_type'">
                <i v-if="item.document_type_id == 1" class="fas fa-folder folder-icon font50 "/>
                <i @click="onShowFile (item.id)" v-else class="font50 e-list-icon"
                   :class="documentIconClass (item)"/>
                <!-- The icon is a CSS background on an empty <i>, so the cell held no
                     text at all: the exports (Excel, PDF, print) read the html of each
                     cell, strip the tags and wrote an empty "Tipo" column. The label is
                     hidden the same way Bootstrap hides text meant only for assistive
                     technology, so the listing keeps showing the icon alone and a screen
                     reader stops announcing an empty cell. -->
                <span class="sr-only">{{ fileTypeLabel (item) }}</span>
              </div>

              <div v-else-if="column == 'updated_at'">
                {{ dateFormat(item.updated_at) }}
              </div>

              <!-- Empty for a folder and for anything uploaded before the size
                   was stored, rather than a "0 B" that would read as an empty
                   file. -->
              <div v-else-if="column == 'size'">
                {{ formatDocumentSize (item.size) }}
              </div>

              <div v-else-if="column == 'file_name'">
                <span class="font-weight-bold" v-if="hasValue (item, column)">
                  {{itemValue (item, column)}}
                </span>
              </div>
              <div class="text-center" v-else-if="column == 'active'">
                <i v-if="itemValue(item, column) == 0" class="fas fa-dot-circle fa-fw fa_danger" ></i>
                <i v-else class="fas fa-dot-circle fa-fw fa_success" ></i>
              </div>
              <div v-else>
                <slot :name="'item.' + column" :item="item">
                  <!-- Fallback si NO hay slot definido en el padre -->
                  <span v-if="hasValue(item, column)">
                    {{ itemValue(item, column) }}
                  </span>
                </slot>
              </div>

            </td>
          </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from "moment";
import { fileErrorHandling, downloadFileName } from "../utils/fileErrors";
import { formatDocumentSize } from "../utils/fileSize";

// The icon of the listing is picked by document_type_id, but some extensions share a
// type and have a sprite of their own: a .rar is an archive (type 5) just like a .zip
// and must not show up with the icon of the zip. Here the extension wins over the type.
// Same rule as FileExplorer.documentIconClass.
const EXTENSION_ICON_CLASS = {
  rar: 'e-fe-rar'
};

  export default {
    name: 'l-table',
    mixins: [fileErrorHandling],
    props: {
      columns: Array,
      data: Array,
      urlDownload : String,
      section: String,
      urlEmail : String,
      // Optional predicate the parent can pass to hide the delete button on
      // specific rows (e.g. a logged in user must not be able to delete their
      // own account). When it is not given, every row stays deletable.
      canDelete : {
        type : Function,
        default : null
      }
    },
    computed: {
      // The header checkbox had no state of its own, so it stayed ticked after the
      // rows were unticked one by one or the selection was cleared from outside.
      isAllChecked () {
        return this.data.length > 0 && this.check_value.length === this.data.length;
      }
    },
    data(){
      return {
        iconClass: {
          2 : 'e-fe-pdf',
          3 : 'e-fe-docx',
          4 : 'e-fe-image',
          5 : 'e-fe-zip',
          6 : 'e-fe-pptx',
          7 : 'e-fe-xlsx',
          8 : 'e-fe-music',
          9 : 'e-fe-video',
          10 : 'e-fe-txt',
          11 : 'e-fe-msg',
        },
        arrayColumns : ['show_image','check','edit','edit_event','delete_event','actions','actions_event','url','download','show','active','id','show_file','download_file','view_download'],
        actionColumns : ['edit','edit_event','delete_event','actions','actions_event','show_file','download_file','view_download'],
        check_value : [],
        shiftKeyOn: false
      }
    },
    methods: {
      // inspired by: https://codepen.io/sirlancelot/pen/grLdgo?editors=1010
      keyEvent() {
        this.shiftKeyOn = true;
      },
      // The API serves dates in ISO 8601 (the Laravel default), so they are read as
      // such instead of against a fixed pattern, which left them unparseable.
      dateFormat (dateToBeFormatted) {
        const date = moment (dateToBeFormatted);
        return dateToBeFormatted && date.isValid () ? date.format ("DD/MM/YY HH:mm") : "";
      },
      // Size of a document for its cell: empty for a folder and for anything the
      // backfill has not reached yet.
      formatDocumentSize (value) {
        return formatDocumentSize (value);
      },
      // Sort key of the date column, carried in data-order: DataTables would otherwise
      // order on the text of the cell and sort "DD/MM/YY" by day.
      dateSortKey (dateToBeFormatted) {
        const date = moment (dateToBeFormatted);
        return dateToBeFormatted && date.isValid () ? date.unix () : "";
      },
      // The columns whose cell shows something other than what it should be ordered
      // by. Both would otherwise be sorted as text: the date by day, and the size as
      // "1.2 MB", which lands before "900 KB". A null leaves the attribute out and
      // DataTables falls back to the text of the cell, which is right everywhere else.
      sortKey (item, column) {
        if (column == "updated_at") return this.dateSortKey (item.updated_at);
        // A document with no size sorts as an empty file rather than dropping to a
        // random place: the cell is blank and 0 is what it reads as.
        if (column == "size") return Number (item.size) || 0;
        return null;
      },
      // Extension of a row, lowercase and without the dot. Empty when the name carries
      // no real extension: the tail after the last dot would otherwise be a piece of
      // the name itself.
      fileExtension (item) {
        const name = (item && (item.name || item.file_name)) || "";
        const dot = name.lastIndexOf (".");
        const extension = name.slice (dot + 1);

        return dot > 0 && /^[a-z0-9]{1,8}$/i.test (extension) ? extension.toLowerCase () : "";
      },
      // Type of a row as text: its extension, because document_type_id groups
      // extensions that are not the same file (a .rar and a .zip share type 5).
      fileTypeLabel (item) {
        if (item.document_type_id == 1) return this.$t ("folder");

        return this.fileExtension (item).toUpperCase ();
      },
      // Icon of a row, with the extension winning over the type where it has a sprite
      // of its own. Same rule as FileExplorer.documentIconClass.
      documentIconClass (item) {
        return EXTENSION_ICON_CLASS [this.fileExtension (item)] || this.iconClass [item.document_type_id];
      },
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      },
      onDonwloadContract(id){
        this.$store.dispatch('isLoadingOn');
        this.$axios( this.urlDownload + id, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.dispatch('isLoadingOff');
            var file = new Blob([response.data], {type: 'application/pdf'});
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(file);
            var link = document.createElement('a');
            link.href = data;
            link.target="_blank";
            link.click(); 
          })
          .catch(() => {
            this.$store.dispatch('isLoadingOff');
          })
       
      },
      onCheckItem(){
        //console.log(this.check_value);
        this.$emit("onCheckItem",this.check_value);
      },
      onPressEdit(item){
        this.$emit("editEvent",item)
      },
      isDeletable(item){
        return this.canDelete ? this.canDelete (item) : true;
      },
      onPressDelete(item,index){
        // Guarded here too, not only with the v-if above: the emit is the only
        // door to the parent's delete handler.
        if (!this.isDeletable (item)) return;
        this.$emit("deleteEvent",item,index)
      },
      onShowFile(id){
        this.$store.dispatch('isLoadingOn');
        this.$axios( this.urlDownload + id)
            .then((response) => {
              this.$store.dispatch('isLoadingOff');
              let file = response.data;
              if(file.type == "BASE64"){
                var byteCharacters = atob(file.url);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file64 = new Blob([byteArray], { type: 'application/pdf;base64' });
                var fileURL = URL.createObjectURL(file64);
                window.open(fileURL);
              }
              else{
                window.open(file.url);
              }
            })
            .catch((error) => {
              this.$store.dispatch('isLoadingOff');
              this.onFileError(error, this.getRowName(id));
            })

      },
      // Best effort: the name only makes the warning concrete, so a row that
      // cannot be matched just yields a generic message.
      getRowName(id){
        const row = (this.data || []).find((item) => item.id == id);
        return row && row.name ? row.name : null;
      },
      onDonwloadFile(id){
        this.$store.dispatch ('isLoadingOn');
        this.$axios ({
          url: '/document/download_file/'+id, //your url
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', downloadFileName(response, this.getRowName(id) || "documento"));
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.onFileError(error, this.getRowName(id));
        })
        // Every exit switches the overlay off, not just the happy path.
        .finally(() => {
          this.$store.dispatch ('isLoadingOff');
        });
      },
      onSendContract(id){
        this.$emit("send_contract",id);
      },
      onDonwloadEvent(item){
        this.$emit("donwloadImage",item.id);
      },
      onUploadContract(item){
        this.$emit("upload_contract",item);
      },
      getUsers(users){
        let html = ""; 
        let index = 1;
        for( let row in users){
            if(index % 2 == 0)
              html += "<hr class='m-2'>";  
            html += "<ul class='mb-0'>";
            // <i class='fas fa-check mr-2 text-success'></i>
            users[row].forEach(element => {
              html += "<li > <div class='d-flex'><div style='min-width:105px'>"+element.name+"</div> " +  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(element.amount)+" | "+element.date+"</div></li>";
            });
            html += "</ul>";
            index++;                     
        } 
        return html;

      },
      checkAllItems(event){
        if(event.target.checked){
          this.check_value = []
          this.data.forEach((item) => {
            this.check_value.push(item.id)
          })
          this.$emit("onCheckItem",this.check_value);
        }
        else{
          this.check_value = [];
          this.$emit("onCheckItem",this.check_value);
        }
      },
      // Clears the selection from outside, for the "N selected" counter of a listing.
      clearSelection () {
        this.check_value = [];
        this.$emit ("onCheckItem", this.check_value);
      }
    }
  }
</script>
<style>
.table > tbody > tr > td{
  font-size: 13px;
}
 .text-blue {
    color: #007bff !important;
}
.w-5{
  width: 5%;
}
.font7{
  font-size: 7px;
}
.tooltip-inner ul{
    margin-bottom: 5px;
    padding-left: 2rem;
    padding-right: 1rem;
    text-align: left;
}
.fa_danger{color: #dc3545}
.fa_success{color: #28a745}


/*Icons */
.e-list-icon {
  display: inline-flex;
  height: 20px;
  width: 20px;
  background-size: contain;
  background-position: center;
}
.e-fe-pdf {
  background-image: url("/images/file-icons/pdf.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-docx {
  background-image: url("/images/file-icons/docx.svg");
  background-repeat: no-repeat;
}
.e-fe-pptx {
  background-image: url("/images/file-icons/pptx.svg");
  background-repeat: no-repeat;
}
.e-fe-xlsx {
  background-image: url("/images/file-icons/xlsx.svg");
  background-repeat: no-repeat;
}
.e-fe-image {
  background-image: url("/images/file-icons/image.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-rar {
  background-image: url("/images/file-icons/rar.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-zip {
  background-image: url("/images/file-icons/zip.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-txt {
  background-image: url("/images/file-icons/txt.svg");
  background-repeat: no-repeat;
}
.e-fe-msg {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMjc5NGE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjYWZmZTE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9YTUw8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTcuNzEsMTQuODFsMS4xLDIuNzdMOS45LDE0LjgxaDEuODlMOS44LDE5bDIuMTMsNC4zNEgxMEw4Ljc1LDIwLjQ3LDcuNTMsMjMuMzhINS42M0w3Ljc3LDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMjEsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxOC42NlYxNi41NGgwbC0xLjUyLDYuODRIMTUuNzdsLTEuNTItNi44NGgwdjYuODRIMTIuNjRWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjEuNDgsMTQuODFoMS43M1YyMmgzLjA2djEuNDJIMjEuNDhaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-music {
  background-image: url("/images/file-icons/music.svg");
  background-repeat: no-repeat;
}
.e-fe-video {
  background-image: url("/images/file-icons/video.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.e-fe-js {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MmJiMjI7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNlOWZmYjg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9KUzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMTQsMjFhMi41NywyLjU3LDAsMCwxLS42NCwxLjk1LDIuODMsMi44MywwLDAsMS0xLjk0LjU4LDIuODQsMi44NCwwLDAsMS0xLjEzLS4xOSwxLjYsMS42LDAsMCwxLS42OS0uNTMsMiwyLDAsMCwxLS4zNi0uNzksNSw1LDAsMCwxLS4wOS0xdi0uMzhoMS41OHYuMjdhMi41OCwyLjU4LDAsMCwwLC4xNSwxLC42MS42MSwwLDAsMCwuNjIuMzMuNjEuNjEsMCwwLDAsLjYyLS4zMywyLjU4LDIuNTgsMCwwLDAsLjE1LTFWMTQuODFoMS43M1oiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNy42NiwyMWEzLjE2LDMuMTYsMCwwLDAsMCwuNTUsMS4xOSwxLjE5LDAsMCwwLC4xOC40MSwxLDEsMCwwLDAsLjM2LjI3LDEuNDksMS40OSwwLDAsMCwuNTYuMDksMS4wNiwxLjA2LDAsMCwwLC43MS0uMjYsMSwxLDAsMCwwLC4zMi0uNzksMS40NiwxLjQ2LDAsMCwwLS4wOC0uNSwxLDEsMCwwLDAtLjI2LS4zOEEyLjI1LDIuMjUsMCwwLDAsMTksMjBjLS4yLS4wOS0uNDQtLjE4LS43My0uMjhhNi43LDYuNywwLDAsMS0xLS40MiwyLjgsMi44LDAsMCwxLS43MS0uNTMsMi4xLDIuMSwwLDAsMS0uNDEtLjcxLDIuOTQsMi45NCwwLDAsMS0uMTMtLjkzLDIuMzgsMi4zOCwwLDAsMSwuNzEtMS45LDIuODYsMi44NiwwLDAsMSwxLjk0LS42Miw0LDQsMCwwLDEsMS4wNi4xMywyLjE5LDIuMTksMCwwLDEsLjg0LjQsMS44NywxLjg3LDAsMCwxLC41NS43MiwyLjQ2LDIuNDYsMCwwLDEsLjIsMS4wNXYuMjRIMTkuN2ExLjc2LDEuNzYsMCwwLDAtLjIyLS45NC43OS43OSwwLDAsMC0uNzItLjMzLDEuMTQsMS4xNCwwLDAsMC0uNDguMDkuNzkuNzksMCwwLDAtLjMxLjIyLjg2Ljg2LDAsMCwwLS4xNS4zMiwxLjUsMS41LDAsMCwwLDAsLjM3LDEuMjQsMS4yNCwwLDAsMCwuMTYuNjYsMS41OCwxLjU4LDAsMCwwLC43Mi41bDEuMzQuNThhMy45MywzLjkzLDAsMCwxLC44LjQ1LDIuMTUsMi4xNSwwLDAsMSwuNS41LDEuNzksMS43OSwwLDAsMSwuMjYuNiwzLjgyLDMuODIsMCwwLDEsLjA3LjcyLDIuMzQsMi4zNCwwLDAsMS0uNzksMiwzLjQ2LDMuNDYsMCwwLDEtMi4xOS42MiwyLjg0LDIuODQsMCwwLDEtMi4wOS0uNjQsMi40NywyLjQ3LDAsMCwxLS42My0xLjgyVjIwLjdoMS43M1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-css {
  background-image: url("data:image/svg+xml;base64,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");
  background-repeat: no-repeat;
}
.e-fe-html {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MjNhOWI7fS5jbHMtMntmaWxsOiNlY2JkZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9IVE1MPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMiwwSDRBMiwyLDAsMCwwLDIsMlYzMGEyLDIsMCwwLDAsMiwySDI4YTIsMiwwLDAsMCwyLTJWOFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIwLjY0LDI2Ljc3bC0xLjI4LTEuNTRMMjQuNDQsMjFsLTUuMDgtNC4yMywxLjI4LTEuNTQsNiw1YTEsMSwwLDAsMSwwLDEuNTRaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTEuMjgsMjYuNzdsLTYtNWExLDEsMCwwLDEsMC0xLjU0bDYtNSwxLjI4LDEuNTRMNy40OCwyMWw1LjA4LDQuMjNaIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI3Ljc1IiB5PSIyMCIgd2lkdGg9IjE2LjQ5IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjI2IDMxLjQyKSByb3RhdGUoLTc1Ljk1KSIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-php {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM3MzcxY2M7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNkY2RjZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9QSFA8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEwLjA2LDE0LjgxYTIuNDcsMi40NywwLDAsMSwxLjExLjIyLDIuMTEsMi4xMSwwLDAsMSwuNzMuNTgsMi4zOSwyLjM5LDAsMCwxLC4zOS44MiwzLjgxLDMuODEsMCwwLDEsLjEyLjk1LDIuOTIsMi45MiwwLDAsMS0uMiwxLjE1LDIsMiwwLDAsMS0uNTUuOCwyLjE3LDIuMTcsMCwwLDEtLjg2LjQ3QTMuODEsMy44MSwwLDAsMSw5LjY5LDIwSDguNzZ2My40Mkg3VjE0LjgxWm0tLjUzLDMuODdhMS4xNSwxLjE1LDAsMCwwLC44NC0uMzEsMS4zMiwxLjMyLDAsMCwwLC4zMS0xLDEuNTMsMS41MywwLDAsMC0uMjctMSwxLjEzLDEuMTMsMCwwLDAtLjkzLS4zNEg4Ljc2djIuNloiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNSwxNC44MXYzLjI3aDJWMTQuODFoMS43M3Y4LjU3SDE3VjE5LjU3SDE1djMuODFIMTMuMjZWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjMsMTQuODFhMi40NywyLjQ3LDAsMCwxLDEuMTEuMjIsMi4xMSwyLjExLDAsMCwxLC43My41OCwyLjM5LDIuMzksMCwwLDEsLjM5LjgyLDMuODEsMy44MSwwLDAsMSwuMTIuOTUsMi45MiwyLjkyLDAsMCwxLS4yLDEuMTUsMiwyLDAsMCwxLS41NS44LDIuMTcsMi4xNywwLDAsMS0uODYuNDcsMy44MSwzLjgxLDAsMCwxLTEuMTEuMTZoLS45M3YzLjQySDE5Ljk0VjE0LjgxWm0tLjUzLDMuODdhMS4xNSwxLjE1LDAsMCwwLC44NC0uMzEsMS4zMiwxLjMyLDAsMCwwLC4zMS0xLDEuNTMsMS41MywwLDAsMC0uMjctMSwxLjEzLDEuMTMsMCwwLDAtLjkzLS4zNGgtLjcydjIuNloiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-exe {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0YjQ4NGM7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNkNmQ2ZDY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGU8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExLjgyLDE2LjIySDguNzZ2MmgyLjg4djEuNDJIOC43NlYyMmgzLjE4djEuNDJIN1YxNC44MWg0Ljc4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTE0LjM2LDE0LjgxbDEuMSwyLjc3LDEuMDktMi43N2gxLjg5bC0yLDQuMjMsMi4xNCw0LjM0SDE2LjY0TDE1LjQsMjAuNDdsLTEuMjIsMi45MWgtMS45TDE0LjQyLDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjQsMTYuMjJIMjF2MmgyLjg4djEuNDJIMjFWMjJoMy4xOHYxLjQySDE5LjI1VjE0LjgxSDI0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIyLDBWN2ExLDEsMCwwLDAsMSwxaDdaIi8+PC9zdmc+");
  background-repeat: no-repeat;
}
.e-fe-msi {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ZGJjYzE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNhZmVmZWQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9NU0k8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTkuNjQsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxMy4xVjE2LjU0aDBsLTEuNTIsNi44NEgxMC4yTDguNjgsMTYuNTRoMHY2Ljg0SDcuMDdWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTcuMzEsMjFhMi4zOSwyLjM5LDAsMCwwLC4wNS41NS45LjksMCwwLDAsLjE4LjQxLjg5Ljg5LDAsMCwwLC4zNS4yNywxLjQ5LDEuNDksMCwwLDAsLjU2LjA5LDEuMDYsMS4wNiwwLDAsMCwuNzEtLjI2LDEsMSwwLDAsMCwuMzItLjc5LDEuNDYsMS40NiwwLDAsMC0uMDgtLjUsMSwxLDAsMCwwLS4yNi0uMzgsMiwyLDAsMCwwLS40Ny0uMzFjLS4yLS4wOS0uNDQtLjE4LS43My0uMjhhNi43LDYuNywwLDAsMS0xLS40MiwyLjU4LDIuNTgsMCwwLDEtLjctLjUzLDIsMiwwLDAsMS0uNDItLjcxLDIuOTQsMi45NCwwLDAsMS0uMTMtLjkzLDIuNDIsMi40MiwwLDAsMSwuNzEtMS45LDIuODYsMi44NiwwLDAsMSwxLjk0LS42MiwzLjksMy45LDAsMCwxLDEuMDYuMTMsMi4xOSwyLjE5LDAsMCwxLC44NC40LDIsMiwwLDAsMSwuNTYuNzJBMi42MiwyLjYyLDAsMCwxLDIxLDE2Ljk0di4yNEgxOS4zNWExLjY4LDEuNjgsMCwwLDAtLjIyLS45NC43OS43OSwwLDAsMC0uNzItLjMzLDEuMTQsMS4xNCwwLDAsMC0uNDguMDkuNjkuNjksMCwwLDAtLjMuMjIuNzQuNzQsMCwwLDAtLjE2LjMyLDEuNSwxLjUsMCwwLDAsMCwuMzcsMS4xNiwxLjE2LDAsMCwwLC4xNy42NiwxLjQ3LDEuNDcsMCwwLDAsLjcyLjVsMS4zMy41OGEzLjY3LDMuNjcsMCwwLDEsLjguNDUsMiwyLDAsMCwxLC41LjUsMS43OSwxLjc5LDAsMCwxLC4yNi42LDMuMTQsMy4xNCwwLDAsMSwuMDcuNzIsMi4zNCwyLjM0LDAsMCwxLS43OSwyLDMuNDYsMy40NiwwLDAsMS0yLjE5LjYyLDIuODQsMi44NCwwLDAsMS0yLjA5LS42NCwyLjQ3LDIuNDcsMCwwLDEtLjYzLTEuODJWMjAuN2gxLjczWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIyLjIzLDE0LjgxSDI0djguNTdIMjIuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-unknown {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZjg2MmM7fS5jbHMtMntvcGFjaXR5OjAuNDU7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9FeGNsYW1hdG9yeTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIsMEg0QTIsMiwwLDAsMCwyLDJWMzBhMiwyLDAsMCwwLDIsMkgyOGEyLDIsMCwwLDAsMi0yVjhaIi8+PGcgY2xhc3M9ImNscy0yIj48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvZz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTcuNDcgMjAgMTQuNSAyMCAxNCA4IDE4IDggMTcuNDcgMjAiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjE2IiBjeT0iMjQiIHI9IjIiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-fe-rtf {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDkwZDg7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjNWVmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9SVEY8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExLjIzLDE0LjgxYTIuNDIsMi40MiwwLDAsMSwxLjY4LjU0LDIuMTYsMi4xNiwwLDAsMSwuNiwxLjY3LDIuNjMsMi42MywwLDAsMS0uMzUsMS40MSwxLjYzLDEuNjMsMCwwLDEtMS4wOC43djBhMS42NSwxLjY1LDAsMCwxLC45NS40MiwxLjgzLDEuODMsMCwwLDEsLjM3LDEuMDVjMCwuMTYsMCwuMzMsMCwuNTJzMCwuNCwwLC42M2MwLC40NSwwLC44LjA3LDFhLjY2LjY2LDAsMCwwLC4zMS40OXYuMDhIMTJBMSwxLDAsMCwxLDExLjgsMjNhMy43MywzLjczLDAsMCwxLDAtLjQ4bDAtMS42NWExLjQsMS40LDAsMCwwLS4yNS0uNzksMSwxLDAsMCwwLS43Ny0uMjlIOS43NnYzLjYzSDhWMTQuODFabS0uNzUsMy43NGExLjQzLDEuNDMsMCwwLDAsMS0uMjksMS4yNSwxLjI1LDAsMCwwLC4zNC0xLDEuMDYsMS4wNiwwLDAsMC0xLjItMS4xOUg5Ljc2djIuNDdaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTkuNTEsMTYuMjJIMTcuNjR2Ny4xNkgxNS45MVYxNi4yMkgxNFYxNC44MWg1LjQ3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI1LDE0LjgxdjEuNDFIMjJ2MmgyLjg4djEuNDJIMjJ2My43MkgyMC4yNVYxNC44MVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMiwwVjdhMSwxLDAsMCwwLDEsMWg3WiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
}
.e-fe-xml {
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMjc5NGE7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNjYWZmZTE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5NdF9YTUw8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLDBINEEyLDIsMCwwLDAsMiwyVjMwYTIsMiwwLDAsMCwyLDJIMjhhMiwyLDAsMCwwLDItMlY4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTcuNzEsMTQuODFsMS4xLDIuNzdMOS45LDE0LjgxaDEuODlMOS44LDE5bDIuMTMsNC4zNEgxMEw4Ljc1LDIwLjQ3LDcuNTMsMjMuMzhINS42M0w3Ljc3LDE5bC0yLTQuMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTUuMjEsMTQuODFsMS4yMiw2aDBsMS4yMy02aDIuNTZ2OC41N0gxOC42NlYxNi41NGgwbC0xLjUyLDYuODRIMTUuNzdsLTEuNTItNi44NGgwdjYuODRIMTIuNjRWMTQuODFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjEuNDgsMTQuODFoMS43M1YyMmgzLjA2djEuNDJIMjEuNDhaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjIsMFY3YTEsMSwwLDAsMCwxLDFoN1oiLz48L3N2Zz4=");
  background-repeat: no-repeat;
}
.e-switch-wrapper {
  height: 25px;
  width: 50px;
}
.e-switch-wrapper input{
  display: none;
}
</style>
